<template>
    <div class="form-input">
        <label :for="fieldId">
            <span>{{ label }}</span>
        </label>
        <select :id="fieldId" :value="value" :name="name" @keyup.enter="handleEnter" @change="$emit('input', $event.target.value)">
            <option v-for="option in options" :key="option._uid" :value="option.value">
                {{ option.label }}
            </option>
        </select>
    </div>
</template>

<script>
export default {

    props: {
        value: {
            default: ''
        },
        options: {
            default: []
        },
        name: {
            required: true
        },
        label: {
            required: true
        }
    },

    computed: {
        fieldId () {
            return this.name.toLowerCase();
        }
    },

};
</script>
<style scoped>
.form-input {
    border: solid 1px #000;
    position: relative;
    height: 47px;
}
.form-input select {
    background: transparent;
    border: none;
    display: block;
    padding: 22px 10px 5px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
    color: #000;
}
.form-input label {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 12px;
    display: block;
    padding: 0px 10px 0 10px;
    z-index: 5;
    position: relative;
}
</style>